import CodeEditor from '@uiw/react-textarea-code-editor';
import { useColors, useColorMode } from '../../theme/ColorModeContext';
import { getCodeLanguageFromClassName } from '../../utils/codeLanguage';

interface Node {
    className?: string | string[];
    children: string;
}
interface CodeProps {
    node: Node;
}

const Code = (props: CodeProps) => {
    const colors = useColors();
    const { mode } = useColorMode();
    let node = props.node;
    const language = getCodeLanguageFromClassName(node.className);

    return (
        node.className !== undefined ?
            <CodeEditor
              value={node.children}
              language={language}
              data-color-mode={mode}
              disabled={true}
              style={{
                fontSize: 15,
                fontFamily: '"Share Tech Mono", ui-monospace, SFMono-Regular, SF Mono, Consolas, Liberation Mono, Menlo, monospace',
                margin: '0px',
                padding: '0px',
                backgroundColor: colors.bg.tertiary,
                border: `1px solid ${colors.border.default}`,
                borderRadius: '6px',
              }}
            />
        :
            <span style={{
                fontSize: 14,
                fontFamily: '"Share Tech Mono", ui-monospace, monospace',
                backgroundColor: colors.bg.tertiary,
                padding: '2px 8px',
                border: `1px solid ${colors.border.default}`,
                borderRadius: '4px',
            }}>{node.children}</span>
    );
}

export default Code;
